import React, { useState } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import { StoreDetailPanel } from './StoreDetailPanel';
import { MapLegend } from './MapLegend';
// Status colors
const statusColors = {
  success: '#22c55e',
  warning: '#eab308',
  danger: '#ef4444'
};
// OBI Stores across Europe
const stores = [
// Deutschland
{
  id: 1,
  name: 'OBI Markt Berlin-Steglitz',
  lat: 52.4567,
  lng: 13.3289,
  score: 4.6,
  status: 'success',
  type: 'OBI Markt',
  address: 'Berlin, Steglitz'
}, {
  id: 2,
  name: 'OBI Markt Hamburg-Altona',
  lat: 53.5511,
  lng: 9.9337,
  score: 4.2,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Hamburg, Altona'
}, {
  id: 3,
  name: 'OBI MachBar! Köln',
  lat: 50.9375,
  lng: 6.9803,
  score: 4.7,
  status: 'success',
  type: 'OBI MachBar!',
  address: 'Köln, Deutz'
}, {
  id: 4,
  name: 'OBI Markt München-Freiham',
  lat: 48.1451,
  lng: 11.462,
  score: 4.1,
  status: 'warning',
  type: 'OBI Markt',
  address: 'München, Freiham'
}, {
  id: 5,
  name: 'OBI Gartenparadies Frankfurt',
  lat: 50.1309,
  lng: 8.6921,
  score: 4.8,
  status: 'success',
  type: 'OBI Gartenparadies',
  address: 'Frankfurt, Nordend'
}, {
  id: 6,
  name: 'OBI Markt Stuttgart-Feuerbach',
  lat: 48.8158,
  lng: 9.1629,
  score: 3.9,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Stuttgart, Feuerbach'
}, {
  id: 7,
  name: 'OBI Markt Leipzig-Burghausen',
  lat: 51.3397,
  lng: 12.2731,
  score: 4.3,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Leipzig, Burghausen'
}, {
  id: 8,
  name: 'OBI Markt Dresden-Prohlis',
  lat: 51.0504,
  lng: 13.6373,
  score: 4.5,
  status: 'success',
  type: 'OBI Markt',
  address: 'Dresden, Prohlis'
}, {
  id: 9,
  name: 'OBI Markt Hannover-Linden',
  lat: 52.3659,
  lng: 9.712,
  score: 3.7,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Hannover, Linden'
}, {
  id: 10,
  name: 'OBI Markt Nürnberg-Leyh',
  lat: 49.4521,
  lng: 11.0067,
  score: 3.4,
  status: 'danger',
  type: 'OBI Markt',
  address: 'Nürnberg, Leyh'
}, {
  id: 11,
  name: 'OBI Markt Bremen-Habenhausen',
  lat: 53.0793,
  lng: 8.8517,
  score: 4.4,
  status: 'success',
  type: 'OBI Markt',
  address: 'Bremen, Habenhausen'
}, {
  id: 12,
  name: 'OBI Markt Düsseldorf-Lierenfeld',
  lat: 51.2077,
  lng: 6.8235,
  score: 4.2,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Düsseldorf, Lierenfeld'
}, {
  id: 13,
  name: 'OBI Markt Dortmund-Kley',
  lat: 51.5136,
  lng: 7.3653,
  score: 3.8,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Dortmund, Kley'
}, {
  id: 14,
  name: 'OBI Markt Essen-Altenessen',
  lat: 51.4356,
  lng: 7.0516,
  score: 4.1,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Essen, Altenessen'
}, {
  id: 15,
  name: 'OBI Markt Duisburg-Neumühl',
  lat: 51.4344,
  lng: 6.8123,
  score: 3.2,
  status: 'danger',
  type: 'OBI Markt',
  address: 'Duisburg, Neumühl'
}, {
  id: 16,
  name: 'OBI Markt Bochum-Kray',
  lat: 51.4818,
  lng: 7.2162,
  score: 4.5,
  status: 'success',
  type: 'OBI Markt',
  address: 'Bochum, Kray'
}, {
  id: 17,
  name: 'OBI Markt Wuppertal-Elberfeld',
  lat: 51.2562,
  lng: 7.1508,
  score: 4.0,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Wuppertal, Elberfeld'
}, {
  id: 18,
  name: 'OBI Markt Bielefeld-Brackwede',
  lat: 52.0302,
  lng: 8.5325,
  score: 4.6,
  status: 'success',
  type: 'OBI Markt',
  address: 'Bielefeld, Brackwede'
}, {
  id: 19,
  name: 'OBI Markt Bonn-Nord',
  lat: 50.7351,
  lng: 7.0531,
  score: 4.3,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Bonn, Nord'
}, {
  id: 20,
  name: 'OBI Markt Münster-Gievenbeck',
  lat: 51.9607,
  lng: 7.6261,
  score: 4.7,
  status: 'success',
  type: 'OBI Markt',
  address: 'Münster, Gievenbeck'
}, {
  id: 21,
  name: 'OBI Markt Karlsruhe-Durlach',
  lat: 49.0069,
  lng: 8.4537,
  score: 4.4,
  status: 'success',
  type: 'OBI Markt',
  address: 'Karlsruhe, Durlach'
}, {
  id: 22,
  name: 'OBI Markt Mannheim-Neckarau',
  lat: 49.4875,
  lng: 8.516,
  score: 3.9,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Mannheim, Neckarau'
}, {
  id: 23,
  name: 'OBI Markt Augsburg-Lechhausen',
  lat: 48.3705,
  lng: 10.8978,
  score: 4.2,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Augsburg, Lechhausen'
}, {
  id: 24,
  name: 'OBI Markt Wiesbaden-Biebrich',
  lat: 50.0782,
  lng: 8.2398,
  score: 4.5,
  status: 'success',
  type: 'OBI Markt',
  address: 'Wiesbaden, Biebrich'
}, {
  id: 25,
  name: 'OBI Markt Gelsenkirchen-Buer',
  lat: 51.5126,
  lng: 7.0971,
  score: 3.6,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Gelsenkirchen, Buer'
},
// Österreich
{
  id: 26,
  name: 'OBI MachBar! Wien-Donaustadt',
  lat: 48.2392,
  lng: 16.4475,
  score: 4.8,
  status: 'success',
  type: 'OBI MachBar!',
  address: 'Wien, Donaustadt'
}, {
  id: 27,
  name: 'OBI Markt Wien-Favoriten',
  lat: 48.1611,
  lng: 16.3822,
  score: 4.2,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Wien, Favoriten'
}, {
  id: 28,
  name: 'OBI Markt Graz-Nord',
  lat: 47.0969,
  lng: 15.4125,
  score: 4.5,
  status: 'success',
  type: 'OBI Markt',
  address: 'Graz, Nord'
}, {
  id: 29,
  name: 'OBI Markt Linz-Webling',
  lat: 48.2619,
  lng: 14.2882,
  score: 4.1,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Linz, Webling'
}, {
  id: 30,
  name: 'OBI Markt Salzburg-Seiersberg',
  lat: 47.7981,
  lng: 13.0465,
  score: 4.6,
  status: 'success',
  type: 'OBI Markt',
  address: 'Salzburg, Seiersberg'
}, {
  id: 31,
  name: 'OBI Markt Innsbruck-Süd',
  lat: 47.2692,
  lng: 11.4041,
  score: 4.3,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Innsbruck, Süd'
}, {
  id: 32,
  name: 'OBI Markt Klagenfurt-Ost',
  lat: 46.6247,
  lng: 14.3053,
  score: 4.0,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Klagenfurt, Ost'
}, {
  id: 33,
  name: 'OBI Markt Villach-Nord',
  lat: 46.6111,
  lng: 13.8558,
  score: 4.4,
  status: 'success',
  type: 'OBI Markt',
  address: 'Villach, Nord'
}, {
  id: 34,
  name: 'OBI Markt Wels-Süd',
  lat: 48.1583,
  lng: 14.0286,
  score: 3.8,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Wels, Süd'
}, {
  id: 35,
  name: 'OBI Markt St. Pölten',
  lat: 48.2044,
  lng: 15.6256,
  score: 4.7,
  status: 'success',
  type: 'OBI Markt',
  address: 'St. Pölten'
},
// Schweiz
{
  id: 36,
  name: 'OBI Markt Zürich-Dietlikon',
  lat: 47.4167,
  lng: 8.6167,
  score: 4.5,
  status: 'success',
  type: 'OBI Markt',
  address: 'Zürich, Dietlikon'
}, {
  id: 37,
  name: 'OBI Markt Basel-Pratteln',
  lat: 47.5333,
  lng: 7.7,
  score: 4.3,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Basel, Pratteln'
}, {
  id: 38,
  name: 'OBI Markt Bern-Schönbühl',
  lat: 47.0167,
  lng: 7.4833,
  score: 4.6,
  status: 'success',
  type: 'OBI Markt',
  address: 'Bern, Schönbühl'
}, {
  id: 39,
  name: 'OBI Markt Winterthur',
  lat: 47.5,
  lng: 8.7333,
  score: 4.2,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Winterthur'
}, {
  id: 40,
  name: 'OBI Markt St. Gallen',
  lat: 47.4167,
  lng: 9.3667,
  score: 4.4,
  status: 'success',
  type: 'OBI Markt',
  address: 'St. Gallen'
},
// Tschechien
{
  id: 41,
  name: 'OBI Markt Prag-Štěrboholy',
  lat: 50.0755,
  lng: 14.5422,
  score: 4.1,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Prag, Štěrboholy'
}, {
  id: 42,
  name: 'OBI Markt Prag-Ruzyně',
  lat: 50.0886,
  lng: 14.3153,
  score: 4.4,
  status: 'success',
  type: 'OBI Markt',
  address: 'Prag, Ruzyně'
}, {
  id: 43,
  name: 'OBI Markt Brünn-Modřice',
  lat: 49.1294,
  lng: 16.6083,
  score: 4.0,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Brünn, Modřice'
}, {
  id: 44,
  name: 'OBI Markt Ostrava',
  lat: 49.8209,
  lng: 18.2625,
  score: 4.3,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Ostrava'
}, {
  id: 45,
  name: 'OBI Markt Pilsen',
  lat: 49.7384,
  lng: 13.3736,
  score: 4.5,
  status: 'success',
  type: 'OBI Markt',
  address: 'Pilsen'
},
// Polen
{
  id: 46,
  name: 'OBI Markt Warschau-Ursynów',
  lat: 52.2297,
  lng: 21.0122,
  score: 4.2,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Warschau, Ursynów'
}, {
  id: 47,
  name: 'OBI Markt Krakau-Bronowice',
  lat: 50.0647,
  lng: 19.945,
  score: 4.6,
  status: 'success',
  type: 'OBI Markt',
  address: 'Krakau, Bronowice'
}, {
  id: 48,
  name: 'OBI Markt Breslau-Krzyki',
  lat: 51.1079,
  lng: 17.0385,
  score: 4.0,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Breslau, Krzyki'
}, {
  id: 49,
  name: 'OBI Markt Posen-Bielany',
  lat: 52.4064,
  lng: 16.9252,
  score: 4.3,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Posen, Bielany'
}, {
  id: 50,
  name: 'OBI Markt Danzig',
  lat: 54.352,
  lng: 18.6466,
  score: 4.5,
  status: 'success',
  type: 'OBI Markt',
  address: 'Danzig'
},
// Italien
{
  id: 51,
  name: 'OBI Markt Mailand-Corsico',
  lat: 45.4642,
  lng: 9.19,
  score: 4.4,
  status: 'success',
  type: 'OBI Markt',
  address: 'Mailand, Corsico'
}, {
  id: 52,
  name: 'OBI Markt Rom-Rozzano',
  lat: 41.9028,
  lng: 12.4964,
  score: 4.1,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Rom, Rozzano'
}, {
  id: 53,
  name: 'OBI Markt Turin',
  lat: 45.0703,
  lng: 7.6869,
  score: 4.3,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Turin'
}, {
  id: 54,
  name: 'OBI Markt Verona',
  lat: 45.4384,
  lng: 10.9916,
  score: 4.6,
  status: 'success',
  type: 'OBI Markt',
  address: 'Verona'
}, {
  id: 55,
  name: 'OBI Markt Venedig',
  lat: 45.4408,
  lng: 12.3155,
  score: 4.0,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Venedig'
},
// Ungarn
{
  id: 56,
  name: 'OBI Markt Budapest-Soroksár',
  lat: 47.4979,
  lng: 19.0402,
  score: 4.2,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Budapest, Soroksár'
}, {
  id: 57,
  name: 'OBI Markt Debrecen',
  lat: 47.5316,
  lng: 21.6273,
  score: 4.5,
  status: 'success',
  type: 'OBI Markt',
  address: 'Debrecen'
}, {
  id: 58,
  name: 'OBI Markt Szeged',
  lat: 47.5333,
  lng: 21.6333,
  score: 4.1,
  status: 'warning',
  type: 'OBI Markt',
  address: 'Szeged'
}];
// Export stores for use in other components
export { stores };
export function StoreMap() {
  const [selectedStore, setSelectedStore] = useState<any>(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const handleMarkerClick = (store: any) => {
    setSelectedStore(store);
    setIsPanelOpen(true);
  };
  return <div className="relative w-full h-full bg-gray-100 overflow-hidden" data-id="element-139">
      <MapContainer center={[49.5, 11.0]} zoom={5} style={{
      height: '100%',
      width: '100%'
    }} zoomControl={true} data-id="element-140">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-141" />

        {stores.map(store => <CircleMarker key={store.id} center={[store.lat, store.lng]} radius={8} pathOptions={{
        fillColor: statusColors[store.status as keyof typeof statusColors],
        fillOpacity: 0.9,
        color: '#ffffff',
        weight: 2
      }} eventHandlers={{
        click: () => handleMarkerClick(store)
      }} data-id="element-142">
            <Popup data-id="element-143">
              <div className="text-sm" data-id="element-144">
                <strong data-id="element-145">{store.name}</strong>
                <br data-id="element-146" />
                Bewertung: {store.score} ⭐
              </div>
            </Popup>
          </CircleMarker>)}
      </MapContainer>

      <MapLegend data-id="element-147" />

      <StoreDetailPanel isOpen={isPanelOpen} onClose={() => setIsPanelOpen(false)} store={selectedStore} data-id="element-148" />
    </div>;
}